import React,{ useState, useEffect } from 'react';

import './BaseBanner.less'

const BaseBanner = ({banner}) =>{
  
  if(banner){
    return (
      <div className="BaseBanner-box">
        <img className="BaseBanner-img" src={banner.img} alt="" />
        <span className="BaseBanner-name">{banner.name}</span>
      </div>
    )
  }
}

export default BaseBanner